import React, { useState } from "react";
import { AxiosResponse } from "axios";
import FormInPhieuDialog from "../../component/button-in-phieu/components/PrintDialog";
import einvoiceService from "../services/einvoiceService";

interface Props {
  invoiceId: string;
  onViewPDF?: () => void;
  onHide?: () => void; // Thêm callback khi đóng dialog
  children?: React.ReactNode;
  className?: string;
  title?: string;
  autoOpen?: boolean; // Thêm prop để tự động mở
}

const EinvoicePDFViewer: React.FC<Props> = ({
  invoiceId,
  onViewPDF,
  onHide,
  children,
  className = "btn btn-sm btn-light-primary",
  title,
  autoOpen = false,
}) => {
  const [showPDFDialog, setShowPDFDialog] = useState(autoOpen);

  const handleViewPDF = () => {
    if (onViewPDF) {
      onViewPDF();
    }
    setShowPDFDialog(true);
  };

  const fetchPDF = async (params: {
    ikey: string;
    fileType?: string;
  }): Promise<AxiosResponse<Blob, any>> => {
    return einvoiceService.downloadInvoicePDF(params.ikey);
  };

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={handleViewPDF}
        title={title || "Xem PDF hóa đơn"}
      >
        {children || (
          <>
            <i className="bi bi-file-earmark-pdf me-1"></i>
            Xem PDF
          </>
        )}
      </button>

      {showPDFDialog && (
        <FormInPhieuDialog
          show={showPDFDialog}
          onHide={() => {
            setShowPDFDialog(false);
            if (onHide) {
              onHide();
            }
          }}
          title="Xem PDF Hóa Đơn"
          fetchExport={fetchPDF}
          params={{ ikey: invoiceId }}
        />
      )}
    </>
  );
};

export default EinvoicePDFViewer;
